export default {
  path: '/nozzle_materials',
  name: 'nozzle_materials',
  component: () => import('../components/nozzlematerial/Layout'),
  redirect: { name: 'NozzleMaterialList' },
  meta: {
    breadcrumb: 'profile.nozzle.materials',
  },
  children: [
    {
      name: 'NozzleMaterialList',
      path: '',
      component: () => import('../views/nozzlematerial/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'NozzleMaterialCreate',
      path: 'new',
      component: () => import('../views/nozzlematerial/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'NozzleMaterialUpdate',
      path: ':id/edit',
      component: () => import('../views/nozzlematerial/Update'),
      meta: {
        breadcrumb: 'profile.nozzle.material',
      },
    },
    {
      name: 'NozzleMaterialShow',
      path: ':id',
      component: () => import('../views/nozzlematerial/Show'),
      meta: {
        breadcrumb: 'profile.nozzle.material',
      },
    }
  ]
};
